<div *ngIf="formGroup"
     id="ageForm"
     [formGroup]="formGroup">
    <div class="flex flexJustify--between mt-0050">
        <ng-container *ngIf="showDOB">
            <mat-form-field class="col col--067sm">
                <mat-label>Date Of Birth</mat-label>
                <input matInput
                       type="tel"
                       (blur)="_onTouched()"
                       data-test-id="dob"
                       autocomplete="off"
                       name="dob"
                       id="dob"
                       formControlName="dateOfBirth"
                       placeholder="MM/DD/YYYY"
                       dateMask />
            </mat-form-field>

            <mat-form-field class="col col--033sm">
                <mat-label>Age</mat-label>
                <!-- Placeholder -->
                <input matInput
                       type="tel"
                       (blur)="_onTouched()"
                       data-test-id="age"
                       autocomplete="off"
                       name="age"
                       id="age"
                       formControlName="age" />
            </mat-form-field>
        </ng-container>
    </div>
</div>
